(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nuro]';
  var ACTION_ATTR = 'data-nuro-action';

  function getRoot(node) {
    return node instanceof Element ? node.closest(ROOT_SELECTOR) : null;
  }

  function initSection(root) {
    if (!root || !root.matches(ROOT_SELECTOR)) {
      return;
    }

    if (root.getAttribute('data-nuro') === 'multi-feature-callouts') {
      initMultiFeatureCallouts(root);
    }

    if (root.getAttribute('data-nuro') === 'mode-explorer') {
      initModeExplorer(root);
    }
  }

  function setActiveFeatureTab(root, trigger, options) {
    if (!root || !trigger) {
      return;
    }

    var shouldScrollIntoView = !(options && options.scrollIntoView === false);

    var index = parseInt(trigger.getAttribute('data-nuro-index'), 10);
    if (Number.isNaN(index)) {
      return;
    }

    root.querySelectorAll('.nuro-multi-feature-callouts__tab').forEach(function (tab) {
      var isActive = tab === trigger;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    if (shouldScrollIntoView && typeof trigger.scrollIntoView === 'function') {
      trigger.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    root.querySelectorAll('[data-feature-index]').forEach(function (node) {
      var isActive = parseInt(node.getAttribute('data-feature-index'), 10) === index;
      node.classList.toggle('is-active', isActive);
      node.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  function initMultiFeatureCallouts(root) {
    var activeTab = root.querySelector('.nuro-multi-feature-callouts__tab[aria-selected="true"]');
    if (!activeTab) {
      activeTab = root.querySelector('.nuro-multi-feature-callouts__tab');
    }

    if (activeTab) {
      setActiveFeatureTab(root, activeTab, { scrollIntoView: false });
    }
  }

  function setActiveModeTab(root, trigger) {
    if (!root || !trigger) {
      return;
    }

    var index = parseInt(trigger.getAttribute('data-nuro-index'), 10);
    if (Number.isNaN(index)) {
      return;
    }

    root.querySelectorAll('.nuro-mode-explorer__tab').forEach(function (tab) {
      var isActive = tab === trigger;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    root.querySelectorAll('.nuro-mode-explorer__panel').forEach(function (panel) {
      var isActive = parseInt(panel.getAttribute('data-mode-index'), 10) === index;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    setModeExplorerStageHeight(root);
  }

  function setModeExplorerStageHeight(root) {
    if (!root || root.getAttribute('data-nuro') !== 'mode-explorer') {
      return;
    }

    var stage = root.querySelector('.nuro-mode-explorer__stage');
    if (!stage) {
      return;
    }

    var panels = Array.prototype.slice.call(root.querySelectorAll('.nuro-mode-explorer__panel'));
    if (!panels.length) {
      stage.style.removeProperty('min-height');
      return;
    }

    var maxHeight = 0;

    panels.forEach(function (panel) {
      var prevDisplay = panel.style.display;
      var prevPosition = panel.style.position;
      var prevVisibility = panel.style.visibility;
      var prevPointerEvents = panel.style.pointerEvents;
      var prevInset = panel.style.inset;
      var prevWidth = panel.style.width;

      panel.style.display = 'flex';
      panel.style.position = 'absolute';
      panel.style.visibility = 'hidden';
      panel.style.pointerEvents = 'none';
      panel.style.inset = '0';
      panel.style.width = '100%';

      maxHeight = Math.max(maxHeight, panel.offsetHeight);

      panel.style.display = prevDisplay;
      panel.style.position = prevPosition;
      panel.style.visibility = prevVisibility;
      panel.style.pointerEvents = prevPointerEvents;
      panel.style.inset = prevInset;
      panel.style.width = prevWidth;
    });

    var configuredMin = getModeExplorerConfiguredMinHeight(root);
    var finalMinHeight = Math.max(maxHeight, configuredMin);

    if (finalMinHeight > 0) {
      stage.style.minHeight = finalMinHeight + 'px';
    }
  }

  function getModeExplorerConfiguredMinHeight(root) {
    if (!root) {
      return 0;
    }

    var styles = window.getComputedStyle(root);
    var isMobile = window.matchMedia('(max-width: 999px)').matches;
    var propertyName = isMobile ? '--nuro-me-tabs-min-height-mobile' : '--nuro-me-tabs-min-height-desktop';
    var rawValue = styles.getPropertyValue(propertyName);
    var parsed = parseFloat(rawValue);

    if (Number.isNaN(parsed)) {
      return 0;
    }

    return Math.max(0, parsed);
  }

  function initModeExplorer(root) {
    var activeTab = root.querySelector('.nuro-mode-explorer__tab[aria-selected="true"]');
    if (!activeTab) {
      activeTab = root.querySelector('.nuro-mode-explorer__tab');
    }

    if (activeTab) {
      setActiveModeTab(root, activeTab);
    }

    root.querySelectorAll('.nuro-mode-explorer__icon-large').forEach(function (image) {
      image.addEventListener('load', function () {
        setModeExplorerStageHeight(root);
      });
    });

    setModeExplorerStageHeight(root);
  }

  function getFeatureTabs(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.nuro-multi-feature-callouts__tab'));
  }

  function getActiveFeatureTabIndex(root) {
    var tabs = getFeatureTabs(root);
    var activeIndex = tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });

    return activeIndex >= 0 ? activeIndex : 0;
  }

  function getModeTabs(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.nuro-mode-explorer__tab'));
  }

  function getActiveModeTabIndex(root) {
    var tabs = getModeTabs(root);
    var activeIndex = tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });

    return activeIndex >= 0 ? activeIndex : 0;
  }

  function onTabKeydown(event) {
    var tab = event.target.closest('.nuro-multi-feature-callouts__tab');
    if (!tab) {
      return;
    }

    var root = getRoot(tab);
    if (!root || root.getAttribute('data-nuro') !== 'multi-feature-callouts') {
      return;
    }

    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
      return;
    }

    var tabs = getFeatureTabs(root);
    var currentIndex = tabs.indexOf(tab);
    if (currentIndex === -1) {
      return;
    }

    event.preventDefault();
    var direction = event.key === 'ArrowRight' ? 1 : -1;
    var nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
    var nextTab = tabs[nextIndex];

    setActiveFeatureTab(root, nextTab);
    nextTab.focus();
  }

  function onModeTabKeydown(event) {
    var tab = event.target.closest('.nuro-mode-explorer__tab');
    if (!tab) {
      return;
    }

    var root = getRoot(tab);
    if (!root || root.getAttribute('data-nuro') !== 'mode-explorer') {
      return;
    }

    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
      return;
    }

    var tabs = getModeTabs(root);
    var currentIndex = tabs.indexOf(tab);
    if (currentIndex === -1 || !tabs.length) {
      return;
    }

    event.preventDefault();

    var nextIndex = currentIndex;
    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    }

    var nextTab = tabs[nextIndex];
    setActiveModeTab(root, nextTab);
    nextTab.focus();
  }

  function initAllSections() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  var modeExplorerResizeRaf = null;

  function onResize() {
    if (modeExplorerResizeRaf !== null) {
      window.cancelAnimationFrame(modeExplorerResizeRaf);
    }

    modeExplorerResizeRaf = window.requestAnimationFrame(function () {
      modeExplorerResizeRaf = null;
      document.querySelectorAll('[data-nuro="mode-explorer"]').forEach(function (root) {
        setModeExplorerStageHeight(root);
      });
    });
  }

  function onActionClick(event) {
    var trigger = event.target.closest('[' + ACTION_ATTR + ']');

    if (!trigger) {
      return;
    }

    var root = getRoot(trigger);

    if (!root) {
      return;
    }

    var action = trigger.getAttribute(ACTION_ATTR);

    if (!action) {
      return;
    }

    switch (action) {
      case 'scroll-to': {
        var selector = trigger.getAttribute('data-nuro-target');

        if (!selector) {
          return;
        }

        var target = document.querySelector(selector);

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        break;
      }
      case 'switch-feature': {
        if (root.getAttribute('data-nuro') !== 'multi-feature-callouts') {
          break;
        }

        setActiveFeatureTab(root, trigger);
        break;
      }
      case 'feature-prev':
      case 'feature-next': {
        if (root.getAttribute('data-nuro') !== 'multi-feature-callouts') {
          break;
        }

        var tabs = getFeatureTabs(root);
        if (!tabs.length) {
          break;
        }

        var activeIndex = getActiveFeatureTabIndex(root);
        var delta = action === 'feature-next' ? 1 : -1;
        var nextIndex = (activeIndex + delta + tabs.length) % tabs.length;
        setActiveFeatureTab(root, tabs[nextIndex]);
        break;
      }
      case 'switch-mode': {
        if (root.getAttribute('data-nuro') !== 'mode-explorer') {
          break;
        }

        setActiveModeTab(root, trigger);
        break;
      }
      case 'mode-prev':
      case 'mode-next': {
        if (root.getAttribute('data-nuro') !== 'mode-explorer') {
          break;
        }

        var modeTabs = getModeTabs(root);
        if (!modeTabs.length) {
          break;
        }

        var modeActiveIndex = getActiveModeTabIndex(root);
        var modeDelta = action === 'mode-next' ? 1 : -1;
        var modeNextIndex = (modeActiveIndex + modeDelta + modeTabs.length) % modeTabs.length;
        setActiveModeTab(root, modeTabs[modeNextIndex]);
        break;
      }
      default:
        break;
    }
  }

  document.addEventListener('click', onActionClick);
  document.addEventListener('keydown', onTabKeydown);
  document.addEventListener('keydown', onModeTabKeydown);
  window.addEventListener('resize', onResize);

  document.addEventListener('DOMContentLoaded', initAllSections);

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target;

    if (!(container instanceof Element)) {
      return;
    }

    var root = container.matches(ROOT_SELECTOR) ? container : container.querySelector(ROOT_SELECTOR);

    if (root) {
      initSection(root);
    }
  });
})();
